<template>
	<div class="dropdown">
		<el-dropdown :show-timeout="0" class="avatar-container right-menu-item hover-effect" trigger="click">
			<div class="avatar-wrapper disf ai-c">
				<div class="mr5">
					<img v-if="photo!=''" :src="GLOBAL.picUrl+photo" class="user-avatar">
					<el-avatar icon="el-icon-user-solid" v-else></el-avatar>
				</div>
				<div id="">
					<p class="h40 lh40 fs16 col-fff">
						{{name}}
					</p>
					<p class="h20 fs14 col-fff" style="line-height:0px">
						{{mobile}}
					</p>
				</div>
				<div id="">
					<i class="el-icon-caret-bottom col-fff" />
				</div>
			</div>
			<el-dropdown-menu slot="dropdown">
				<!-- <el-dropdown-item disabled>
          {{name}}
        </el-dropdown-item> -->
				<!-- <el-dropdown-item @click.native="changePwd">
          修改密码
        </el-dropdown-item> -->
				<el-dropdown-item @click.native="logout">
					退出登录
				</el-dropdown-item>
			</el-dropdown-menu>
		</el-dropdown>
		<my-dialog title="修改密码" path="auth/changePwd.vue" ref="myDialog" width="500px" yes></my-dialog>
	</div>
</template>

<script>
	import {
		clear,
		getInfo
	} from "../utils/token";
	export default {
		name: "dropdown",
		computed: {},
		data() {
			return {
				name: "",
				mobile: "",
				photo: ""
			};
		},
		methods: {
			changePwd() {
				this.$refs.myDialog.show();
			},
			logout() {
				clear();
				this.$router.push("/login");
			},
		},
		mounted() {
			let info = getInfo();
			this.name = info.info.name;
			this.mobile = info.info.mobile;
			this.photo = info.info.photo;
		},
	};
</script>

<style lang="scss" scoped>
	.dropdown {
		float: left;

		.right-menu-item {
			display: inline-block;
			padding: 0 8px;
			height: 100%;
			font-size: 18px;
			color: #bfcbd9;
			vertical-align: text-bottom;

			&.hover-effect {
				cursor: pointer;
				transition: background 0.3s;

				&:hover {
					background: rgba(0, 0, 0, 0.025);
				}
			}
		}

		.avatar-container {
			margin-right: 30px;

			.avatar-wrapper {
				position: relative;
				height: 60px;

				// padding-top: 15px;
				.user-avatar {
					cursor: pointer;
					width: 40px;
					height: 40px;
					font-size: 30px;
					border-radius: 100%;
					color: #eee;
				}

				img.user-avatar {
					width: 40px;
					height: 40px;
					border-radius: 100%;
				}

				.el-icon-caret-bottom {
					cursor: pointer;
					position: absolute;
					right: -20px;
					top: 30px;
					font-size: 12px;
				}
			}
		}
	}
</style>
